<div
  class="emd-input-feedback _state_error"
  *ngIf="control.invalid && control.touched"
>
  {{ errorMessage }}
</div>
